import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=e3152882&"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports